import { lazy, Suspense } from 'react';
import { isPublicHost } from './app/publicHost';
import PublicSite from './features/public/PublicSite';

const TenantApp = lazy(() => import('./app/App'));

export default function App() {
  if (isPublicHost(window.location.hostname)) return <PublicSite />;
  return <Suspense fallback={null}><TenantApp /></Suspense>;
}
